export function generateSectionFromJson(group) {
	return `
	<div class="o-cart__section">
		<h2 class="o-cart__section-header">${group[0].section.name}</h2>
		<ul class="o-cart__items">
			${group.map(item => `
			<li class="o-cart__item">
				<span>${item.name}</span>
					<a href="#" data-product-id="${item.id}" data-section-id="${item.section.id}" data-js="cart__remove">
						<span class="a-icon a-link__icon o-cart__delete-icon">
							<svg class="a-icon__asset">
								<use xlink:href="#icon_trashcan" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
							</svg>
						</span>
				</a>
			</li>`).join('')}
		</ul>
	</div>
`;
}
